import React from 'react';
import '../css/Section.css';

function IntroSection() {
  return (
    <section id="overview" className="section light-section">
      <div className="section-container">
        <div className="section-text">
          <p className="eyebrow">Day-and-night power</p>
          <h2>Smart energy storage for 24/7 independence.</h2>
          <p>
            Day-and-night power. Round-the-clock savings.
            Aevolt Everflow captures your excess solar energy so you can use it whenever you need it most whether that's after dark, 
            during a blackout, or anytime you want to step completely off the grid. 
          </p>
          <p>
            With smart, customizable modes, you can easily optimize your power to slash electricity bills, 
            secure emergency backup, and take control of your home's energy efficiency.
          </p>
        </div>
        <div className="section-image power-home-image" aria-label="Home with solar panels and Aevolt Everflow" />
      </div>
    </section>
  );
}

export default IntroSection;
